import { SET_PROMOTION } from "../../redux/constants";

const INITIAL_STATE = {
  singlePromotion: null,
};

export default function PromotionsApprovalReducer(state = INITIAL_STATE, action) {
  //NOSONAR -default parameter is required first in this case
  switch (action.type) {
    case SET_PROMOTION:
      return {
        ...state,
        singlePromotion: action.data,
      };
    default:
      return state;
  }
}
